import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import { observer } from 'mobx-react';

const CountriesQuery = gql`
  query countries {
    countries {
      id
      parentCountryId
      name
      title
      details
      slug
      VATrate
      currency
      language
      code
      flag
      weightUnit
      business {
        id
      }
      states {
        id
        name
        title
        vatRate
      }
    }
  }
`;

interface IInputProps {
  children?: any;
  search?: string;
}

interface IResponse {
  data: any;
}

@observer
class GetCountriesQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {
  public render() {
    const { countries }: any = this.props;
    return this.props.children({ countries });
  }
}

export default compose(
  graphql<IInputProps, Response>(CountriesQuery, {
    name: 'countries',
    options: props => ({ variables: { search: props.search || '' }, ssr: true })
  })
)(GetCountriesQuery);


// WEBPACK FOOTER //
// ./src/components/Query/Countries/Countries.tsx